import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatError } from "@/lib/api";
import { LogIn } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/"); }
    catch (e) { setErr(formatError(e)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Inloggen" subtitle="Welkom terug">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="E-mail" type="email" value={email} onChange={setEmail} testid="login-email" />
        <Field label="Wachtwoord" type="password" value={password} onChange={setPassword} testid="login-password" />
        {err && <div className="text-red-600 text-sm" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 transition disabled:opacity-50" data-testid="login-submit">
          <LogIn size={16}/> {loading ? "Bezig..." : "Inloggen"}
        </button>
        <div className="flex justify-between text-sm pt-2">
          <Link to="/register" className="text-orange-600 hover:underline" data-testid="goto-register">Registreren</Link>
          <Link to="/forgot-password" className="text-slate-600 hover:underline" data-testid="goto-forgot">Wachtwoord vergeten?</Link>
        </div>
      </form>
    </AuthShell>
  );
}

export function AuthShell({ title, subtitle, children, notice }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background gs-grain px-6 relative z-10">
      <div className="w-full max-w-md gs-card p-8">
        <Link to="/" className="text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">Groepspringen Sprongchecker</Link>
        <h1 className="heading-display text-3xl mt-2 mb-1">{title}</h1>
        <p className="text-slate-600 mb-6">{subtitle}</p>
        {notice}
        {children}
      </div>
    </div>
  );
}

export function Field({ label, type = "text", value, onChange, testid, placeholder = "", required = true }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-1 w-full px-3 py-2.5 border border-input rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-orange-500"
        data-testid={testid}
        required={required}
      />
    </label>
  );
}
